import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NotificationState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: NotificationState = {
  data: [],
  isLoading: false,
  error: null,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setNotificationLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setNotificationError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setNotifications, setNotificationLoading, setNotificationError } = notificationSlice.actions;

export default notificationSlice.reducer;
